import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import 'animate.css';

// Import sections
import StemMeaning from '../components/home/StemMeaning';
import AboutSection from '../components/home/AboutSection';
import CoursesSection from '../components/home/CoursesSection';
import EventsSection from '../components/home/EventsSection';
import GallerySection from '../components/home/GallerySection';
import NewsSection from '../components/home/NewsSection';
import ContactSection from '../components/home/ContactSection';
import ClientsSection from '../components/home/ClientsSection';

// Slide images
const slideImages = [
  'https://i.imgur.com/hSK3Q6y.jpg',
  'https://i.imgur.com/b9nGHia.png',
  'https://i.imgur.com/KMsNbCI.gif',
  'https://i.imgur.com/8lBw1an.png'
];

const HomePage = () => {
  const swiperRef = useRef(null);

  // Function to navigate to a specific slide
  const goToSlide = (index) => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slideTo(index);
    }
  };

  return (
    <div>
      {/* Hero Slider */}
      <section className="relative">
        {/* Main Slider */}
        <Swiper
          ref={swiperRef}
          modules={[Navigation, Pagination, Autoplay, EffectFade]}
          effect="fade"
          slidesPerView={1}
          navigation={{
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }}
          pagination={{ 
            clickable: true,
            dynamicBullets: true,
            el: null // Disable default pagination
          }}
          autoplay={{ delay: 5000 }}
          loop={true}
          className="h-[600px]"
        >
          {/* Slide 1 */}
          <SwiperSlide className="relative bg-cover bg-center" style={{ backgroundImage: `url(${slideImages[0]})` }}>
            <div className="absolute inset-0 bg-black bg-opacity-30"></div>
            <div className="container relative z-10 h-full flex flex-col justify-center">
              <div className="max-w-xl text-white">
                <h2 className="text-4xl md:text-6xl font-bold mb-4 bg-theme-blue bg-opacity-60 p-4 border-l-4 border-theme-secondary animate__animated animate__fadeInLeft">
                  STEM Labs
                </h2>
                <h3 className="text-2xl md:text-3xl font-semibold mb-4 bg-theme-blue bg-opacity-60 p-4 border-l-4 border-theme-secondary animate__animated animate__fadeInLeft animate__delay-1s">
                  The Scientist Laboratory
                </h3>
                <p className="mb-8 animate__animated animate__fadeInLeft animate__delay-2s">
                  We provides always our best guidance for our students and always try to make the innovators, scientist, Entrepreneur.
                </p>
                <Link to="/courses" className="btn btn-primary animate__animated animate__fadeInUp animate__delay-3s">
                  Apply Now!
                </Link>
              </div>
            </div>
          </SwiperSlide>

          {/* Slide 2 */}
          <SwiperSlide className="relative bg-cover bg-center" style={{ backgroundImage: `url(${slideImages[1]})` }}>
            <div className="absolute inset-0 bg-black bg-opacity-30"></div>
            <div className="container relative z-10 h-full flex flex-col justify-center items-center">
              <div className="max-w-2xl text-white text-center">
                <h2 className="text-xl md:text-2xl font-semibold mb-4 bg-gray-900 bg-opacity-60 p-4 rounded-full animate__animated animate__fadeInDown">
                  We improve STEM Skills of Students
                </h2>
                <h3 className="text-3xl md:text-5xl font-bold mb-4 bg-theme-blue bg-opacity-60 p-4 animate__animated animate__fadeInDown animate__delay-1s">
                  We teach STEM using Robotics
                </h3>
                <p className="mb-8 animate__animated animate__fadeInUp animate__delay-2s">
                  We provides always our best guidance for our students and always try to make the innovators, scientist, Entrepreneur.
                </p>
                <Link to="/courses" className="btn btn-outline text-white border-white hover:bg-white hover:text-theme-blue animate__animated animate__fadeInUp animate__delay-3s">
                  Apply Now
                </Link>
              </div>
            </div>
          </SwiperSlide>

          {/* Slide 3 */}
          <SwiperSlide className="relative bg-cover bg-center" style={{ backgroundImage: `url(${slideImages[2]})` }}>
            <div className="absolute inset-0 bg-black bg-opacity-30"></div>
            <div className="container relative z-10 h-full flex flex-col justify-center items-end">
              <div className="max-w-xl text-white text-right">
                <h2 className="text-4xl md:text-5xl font-bold mb-4 bg-theme-blue bg-opacity-60 p-4 border-r-4 border-theme-secondary animate__animated animate__fadeInRight">
                  STUDENTS' VIRTUAL PLATFORM
                </h2>
                <h3 className="text-xl md:text-2xl font-semibold mb-4 bg-gray-800 bg-opacity-60 p-4 animate__animated animate__fadeInRight animate__delay-1s">
                  Our Students' new innovations, Pitching & Ideas
                </h3>
                <p className="mb-8 animate__animated animate__fadeInRight animate__delay-2s">
                  You can have a special session for you all to clarify your doubts, problems & suggestions. You can have a individual meeting with the STEM lecture panel.
                </p>
                <a 
                  href="https://makers.stemlabs.edu.lk" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-primary animate__animated animate__fadeInUp animate__delay-3s"
                >
                  View Now
                </a>
              </div>
            </div>
          </SwiperSlide>

          {/* Slide 4 */}
          <SwiperSlide className="relative bg-cover bg-center" style={{ backgroundImage: `url(${slideImages[3]})` }}>
            <div className="absolute inset-0 bg-black bg-opacity-30"></div>
            <div className="container relative z-10 h-full flex flex-col justify-center items-end">
              <div className="max-w-xl text-white text-right">
                <h2 className="text-4xl md:text-5xl font-bold mb-4 bg-theme-blue bg-opacity-60 p-4 border-r-4 border-theme-secondary animate__animated animate__fadeInRight">
                  Book a FREE 1-1 Counselling
                </h2>
                <h3 className="text-xl md:text-2xl font-semibold mb-4 bg-gray-800 bg-opacity-60 p-4 animate__animated animate__fadeInRight animate__delay-1s">
                  Know more about STEM Education?
                </h3>
                <p className="mb-8 animate__animated animate__fadeInRight animate__delay-2s">
                  You can have a special session for you all to clarify your doubts, problems & suggestions. You can have a individual meeting with the STEM lecture panel.
                </p>
                <a 
                  href="https://docs.google.com/forms/d/e/1FAIpQLScicHQwHsB_p8QE6MuM6NKu-4h3jzfZriZk90TYNFTU_L5tBQ/viewform" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-primary animate__animated animate__fadeInUp animate__delay-3s"
                >
                  Book Now
                </a>
              </div>
            </div>
          </SwiperSlide>

          {/* Custom Navigation Arrows - Always visible */}
          <div className="swiper-button-next !text-white !right-5 !w-12 !h-12 bg-theme-blue bg-opacity-50 rounded-full flex items-center justify-center after:!text-2xl hover:bg-theme-secondary transition-all duration-300"></div>
          <div className="swiper-button-prev !text-white !left-5 !w-12 !h-12 bg-theme-blue bg-opacity-50 rounded-full flex items-center justify-center after:!text-2xl hover:bg-theme-secondary transition-all duration-300"></div>
        </Swiper>

        {/* Thumbnails overlaid on the slider */}
        <div className="absolute bottom-10 left-0 right-0 z-20 flex justify-center items-center space-x-3">
          {slideImages.map((image, index) => (
            <div 
              key={index} 
              onClick={() => goToSlide(index)}
              className="h-10 w-10 rounded-full overflow-hidden border-2 border-white cursor-pointer hover:border-theme-secondary transition-all duration-300 hover:scale-110"
            >
              <img 
                src={image} 
                alt={`Slide ${index + 1}`} 
                className="w-full h-full object-cover" 
              />
            </div>
          ))}
        </div>
      </section>

      {/* STEM Meaning Section */}
      <StemMeaning />

      {/* About Section */}
      <AboutSection />

      {/* Courses Section */}
      <CoursesSection />

      {/* Events Section */}
      <EventsSection />

      {/* Gallery Section */}
      <GallerySection />

      {/* News Section */}
      <NewsSection />

      {/* Contact Section */}
      <ContactSection />

      {/* Clients Section */}
      <ClientsSection />
    </div>
  );
};

export default HomePage; 